"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.MIN_THUMB_LENGTH=30,exports.SCROLLING_CLASS_REMOVAL_DELAY=500;
